import { PermissionT } from "../types";

export const mentorshipAssignment = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "mentorship_assignment");
  return !!p;
};

export default mentorshipAssignment;
